import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { HiOutlineLocationMarker } from "react-icons/hi";

export const ShippingAddressSelector = ({ selectedAddress, onClick, onClear }) => {
  const { t } = useTranslation();

  if (selectedAddress) {
    return (
      <div className="card border-success border-2 p-3">
        <div className="d-flex justify-content-between align-items-start">
          <div className="d-flex align-items-start gap-2">
            <HiOutlineLocationMarker size={20} className="text-muted mt-1 flex-shrink-0" />
            <div>
              <p className="fw-bold mb-1">{selectedAddress.name}</p>
              <p className="small text-muted mb-0">
                {selectedAddress.address_1}
                {selectedAddress.address_2 ? `, ${selectedAddress.address_2}` : ""}
                , {selectedAddress.postcode} {selectedAddress.city}
              </p>
            </div>
          </div>
          <div className="d-flex gap-2">
            <Button
              variant="outline-danger"
              size="sm"
              className="rounded-pill"
              onClick={onClear}
            >
              {t("Quitar")}
            </Button>
            <Button
              variant="outline-secondary"
              size="sm"
              className="rounded-pill"
              onClick={onClick}
            >
              {t("Cambiar")}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card border p-3">
      <div className="d-flex justify-content-between align-items-center">
        <p className="text-muted mb-0 small">
          {t("No has seleccionado una dirección de envío")}
        </p>
        <Button
          variant="outline-dark"
          size="sm"
          className="rounded-pill"
          onClick={onClick}
        >
          {t("Elegir dirección")}
        </Button>
      </div>
    </div>
  );
};
